import { useEventListener } from './useEventListener';

/**
 * Custom hook for detecting clicks outside of a referenced element
 * @param {React.RefObject} ref - The ref object for the element to detect outside clicks
 * @param {Function} handler - The callback function to execute when clicking outside
 * @param {string} [mouseEvent='mousedown'] - The mouse event to listen for
 */
export function useClickOutside(ref, handler, mouseEvent = 'mousedown') {
  useEventListener(
    mouseEvent,
    (event) => {
      const el = ref?.current;
      
      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains(event.target)) {
        return;
      }
      
      handler(event);
    },
    document
  );
}